import { inject, Injectable, signal } from "@angular/core";
import { UserPreferencesService } from "../../../feature/user-preferences/user-preferences.service";

@Injectable({ providedIn: 'root' })
export class MainMenuService {

  userPrefService = inject(UserPreferencesService);
  userPrefs = this.userPrefService.userPreferences;
  wasHelpPageOpened = false;
  helpPageAutostart = this.userPrefs()?.helpPageAutostart || false;

  expanded = signal(true);
}
